import { apiClient } from './api'
import { getStoredAttribution } from '../utils/utm'

export type LeadPayload = {
  first_name: string
  last_name?: string
  email?: string
  phone?: string
  pet_name?: string
  pet_species?: string
  pet_breed?: string
  // Address fields — parsed from Google Places autocomplete
  address_street?: string
  address_city?: string
  address_state?: string
  address_zip?: string
  notes?: string
  market_slug?: string
  // Lead origin override — defaults to "web" server-side. Use "chat"
  // for callback requests submitted from the chat widget.
  source?: string
  // Stable per-visitor identifier so the manual chat CTA submission folds
  // into whatever Lead the AI assistant has already been progressively
  // building during the same conversation, instead of creating a duplicate.
  chat_session_id?: string
  // Booking fields — when all three are present, a pending Appointment is
  // created server-side and the user enters as a customer (not a lead).
  service_name?: string
  preferred_date?: string      // ISO date: "YYYY-MM-DD"
  preferred_window?: string    // "morning" | "afternoon" | "evening"
}

export type LeadResponse = {
  ok: true
  lead_id: number
  deduped: boolean
}

// Submits a lead capture form to the public, anonymous lead-intake
// endpoint. Persisted attribution params (UTM triplet, gclid/fbclid,
// landing page, referrer) are attached automatically so the CRM can
// attribute the lead's source.
export async function submitLead(payload: LeadPayload): Promise<LeadResponse> {
  const attribution = getStoredAttribution()
  const { data } = await apiClient.post<LeadResponse>('/leads', {
    lead: { ...payload, ...attribution },
  })
  return data
}
